'use strict'

angular
  .module('basalteApp')
  .constant('BAS_STREAMING', {
    T_ID_DEEZER: 'deezer',
    T_ID_TIDAL: 'tidal',
    T_ID_SPOTIFY: 'spotify'
  })
